import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';

const MetabaseHeader = () => {
    const { t } = useTranslations();
    return (
        <div className="mainbanner metabase-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="metabase-header__decoration metabase-header__decoration--top-right"></div>
            <div className="metabase-header__decoration metabase-header__decoration--bottom-left"></div>

            <section className="services-area ptb-100 metabase-header__content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="services-content it-service-content">
                                <div className="content">
                                    <div className="metabase-header__badge">
                                        {t('metabase_upperHeader_title')}
                                    </div>

                                    <h1 className="metabase-header__title">
                                        {t('metabase_header_title')}
                                    </h1>

                                    <p className="metabase-header__description">
                                        {t('metabase_header_description')}
                                    </p>

                                    <p className="metabase-header__description metabase-header__description--secondary">
                                        {t('metabase_header_description2')}
                                    </p>

                                    {/* CTA Button */}
                                    <a href="/kontakt" className="metabase-header__cta">
                                        {t('metabase_header_cta')}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="services-image metabase-header__image-wrapper">
                                <FadeInAnimation direction="right" delay={100}>
                                    <div className="image metabase-header__image-card">
                                        <Image
                                            src="/images/business-analytics/metabase/metabase-logo.svg"
                                            alt="simplify data - Metabase Entwicklung"
                                            width={0}
                                            height={0}
                                            sizes="100vw"
                                            style={{
                                                width: '100%',
                                                height: 'auto'
                                            }}
                                        />
                                    </div>
                                </FadeInAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default MetabaseHeader;
